const Data = [
  {
    name: "Anmol Kumar Sah",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads26/AnmolKumarSah.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=61572866845795",
    email: "anmolsah930.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/anmol-sah-0b5523285/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BOOhZRegRSiuwKmbHXyHnhw%3D%3D"
  },
  {
    name: "Parin Ranjan",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads26/ParinRanjan.jpeg",
    facebookLink: "",
    email: "parin.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/parin-ranjan-94a462326/"
  },
  {
    name: "Jaya Singh",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads26/JayaSingh.jpeg",
    facebookLink: "https://www.facebook.com/share/1YFEMrw2LA/",
    email: "jayasingh2528.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/jaya-singh-45943532a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Anshul Goyal",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads26/AnshulGoyal.jpeg",
    facebookLink: "",
    email: "anshulgoyal4599.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/anshul-goyal-03943b313?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  }
];

export default Data;